import GrupoReglaCreate from './GrupoReglaCreate';
import GrupoReglaList from './GrupoReglaList';
import GrupoReglaShow from './GrupoReglaShow';
import GrupoReglaEdit from './GrupoReglaEdit';

const indexGrupoRegla = {
    list: GrupoReglaList,
    create: GrupoReglaCreate,
    show: GrupoReglaShow,
    edit: GrupoReglaEdit
};

export default indexGrupoRegla;
